<div class="circuit-hops-section" *ngIf="circuitHops && circuitHops.length > 0">
  <div class="circuit-hops-container">
    <div class="router-path-header">
      <span class="router-path-text">Circuit Hops ({{ circuitHops?.length }})</span>
    </div>
    <div class="router-path-list">
      <table class="router-path-table">
        <thead>
          <tr>
            <th>#</th>
            <th>From</th>
            <th></th>
            <th>To</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let hop of circuitHops; let i = index"
              (click)="hopSelected.emit({hop, index: i})"
              [class.selected-row]="selectedSegmentIndex === i"
              [class.hop-not-visible]="!hop.isVisible"
              [matTooltip]="!hop.isVisible ? 'This hop is not visible on the map due to missing geolocation data' : ''"
              [matTooltipDisabled]="hop.isVisible"
              class="clickable-circuit-row">
            <td class="hop-number">
              {{ i + 1 }}
              <span *ngIf="!hop.isVisible"
                    class="visibility-badge"
                    matTooltip="Not visible on map"
                    matTooltipPosition="right">
                <span class="icon-eye-slash"></span>
              </span>
            </td>
            <td class="hop-from">
              <span *ngIf="hop.fromHasLocation"
                    [class]="hop.fromType === 'identity' ? 'icon-identity' : 'icon-routers'"
                    class="hop-entity-icon"></span>
              <span *ngIf="!hop.fromHasLocation"
                    class="hop-entity-icon unlocated-icon"
                    matTooltip="No geolocation data"
                    matTooltipPosition="right">
                <img src="/assets/svgs/unknown-marker.svg" alt="No location" class="unlocated-marker-img">
              </span>
              <span class="hop-entity-name" [class.missing-location]="!hop.fromHasLocation">
                {{ hop.from }}
              </span>
            </td>
            <td class="hop-arrow">→</td>
            <td class="hop-to">
              <span *ngIf="hop.toHasLocation"
                    [class]="hop.toType === 'identity' ? 'icon-identity' : 'icon-routers'"
                    class="hop-entity-icon"></span>
              <span *ngIf="!hop.toHasLocation"
                    class="hop-entity-icon unlocated-icon"
                    matTooltip="No geolocation data"
                    matTooltipPosition="right">
                <img src="/assets/svgs/unknown-marker.svg" alt="No location" class="unlocated-marker-img">
              </span>
              <span class="hop-entity-name" [class.missing-location]="!hop.toHasLocation">
                {{ hop.to }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
